<div mat-dialog-title class="dialog-title p-3 pr-5 clearfix">
  <h5>
    Select Maintenance Schedule{{ data['multiple'] ? 's' : '' }}
    <span>
      ({{ dataSource.selection.selected.length }})
    </span>
  </h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>

  <form class="form-inline my-2 my-lg-0 float-lg-right" (ngSubmit)="dataSource.getData(true)">
    <input
      class="form-control mr-2 my-1"
      type="search"
      [(ngModel)]="dataSource.search"
      name="search"
      placeholder="Search"
      aria-label="Search"/>

    <button
      mat-raised-button
      color="secondary"
      class="mr-2 mr-lg-3 my-1"
      type="submit"
      matTooltip="Run the current search">
      <mat-icon>search</mat-icon> Search
    </button>

    <button
      mat-raised-button
      type="button"
      class="mr-2 my-1"
      (click)="onClearSelected()">
      Clear Selected
    </button>
  </form>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    matSortActive="id"
    matSortDirection="asc"
    matSortDisableClear >
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox
          (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)"
          appMarginRight>
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Toggle sorting by the id of the maintenance schedule.">
        #
      </th>
      <td mat-cell *matCellDef="let schedule">
        {{ schedule.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the maintenance schedule." [style.width.px]="250">
        Title
      </th>
      <td mat-cell *matCellDef="let schedule">
        {{ schedule.title }}
      </td>
    </ng-container>

    <ng-container matColumnDef="schedule_mode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the mode of maintenance schedule.">
        Schedule Mode
      </th>
      <td mat-cell *matCellDef="let schedule">
        {{ assetMaintenanceSchedulesService.getScheduleModeLabel(schedule.schedule_mode) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="maintenance_type">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="200">
        Maintenance Type
      </th>
      <td mat-cell *matCellDef="let schedule">
        {{ assetMaintenanceSchedulesService.getMaintenanceTypeLabel(schedule.maintenance_type) }}
        <ng-container *ngIf="assetMaintenanceRecordsService.isOtherType(schedule.maintenance_type) && schedule.maintenance_type_other">
          - {{ schedule.maintenance_type_other }}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="flags">
      <th mat-header-cell *matHeaderCellDef class="no-padding" [style.width.px]="100">
        <div class="d-flex align-items-center">
          <span>Flags</span>
          <button
            type="button"
            mat-icon-button
            class="header-info-help-button"
            matTooltip="What do these flags mean?"
            aria-label="Explain Maintenance Schedule flags"
            (click)="onOpenFlagsLegend()">
            <mat-icon>help_outline</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let schedule" class="no-padding text-wrap">
        <mat-icon *ngIf="schedule.enabled" matTooltip="Schedule Enabled." class="schedule-enabled-yes">power_settings_new</mat-icon>
        <mat-icon *ngIf="schedule.is_recurring" matTooltip="Recurring Schedule." class="recurring-yes">repeat</mat-icon>
        <mat-icon *ngIf="schedule.auto_create" matTooltip="Automatically Creates Maintenance Records." class="auto-create-yes">note_add</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="default_priority">
      <th mat-header-cell *matHeaderCellDef>
        Default Priority
      </th>
      <td mat-cell *matCellDef="let schedule">
          <span [style.color]="assetMaintenanceRecordsService.getPriorityColor(schedule.default_priority) || null">
            {{ assetMaintenanceSchedulesService.getPriorityLabel(schedule.default_priority) }}
          </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="next_due_at">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the due date of the maintenance schedule.">
        Next Due Date
      </th>
      <td mat-cell *matCellDef="let schedule">
          <span [style.color]="utils.getDueDateColor(schedule.next_due_at) || null">
            {{ schedule.next_due_at ? ((schedule.next_due_at * 1000) | timezoneConvertMedium) : '' }}
          </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="next_auto_create_at">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the auto create date of the maintenance schedule.">
        Next Auto Create Date
      </th>
      <td mat-cell *matCellDef="let schedule">
          <span [style.color]="utils.getDueDateColor(schedule.next_auto_create_at) || null">
            {{ schedule.next_auto_create_at ? ((schedule.next_auto_create_at * 1000) | timezoneConvertMedium) : '' }}
          </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="users">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Assigned Users
      </th>
      <td mat-cell *matCellDef="let schedule" class="no-padding">
        <ng-container *ngIf="schedule?.users?.length">
            <span *ngFor="let user of schedule.users | slice:0:MAX_VISIBLE_ASSIGNED_USERS">
              <a (click)="onUserPublicView(user.hash)" matTooltip="View User Public Profile">
                {{ user.contact_person }}
              </a><br>
            </span>
          <span *ngIf="schedule.users.length > MAX_VISIBLE_ASSIGNED_USERS" [matTooltip]="getRemainingUsersTooltip(schedule.users)">
              {{ schedule.users.length - MAX_VISIBLE_ASSIGNED_USERS }} more users
            </span>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header matTooltip="Toggle sorting by the created at date of the vendor.">
        Created At
      </th>
      <td mat-cell *matCellDef="let schedule" class="no-padding">
        {{ (schedule.date_created * 1000) | timezoneConvertMedium }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="dataSource.selection.toggle(row.id)"></tr>
  </table>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-3 py-1">
  <mat-paginator
    class="my-2 ml-1 mr-2"
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>

  <button
    class="my-2 mx-1"
    mat-raised-button
    color="primary"
    type="button"
    (click)="onSaveAndClose()"
    [disabled]="data['required'] && !dataSource.selection.hasValue()">
    Select & Close
  </button>
</mat-dialog-actions>





